module.exports = __webpack_public_path__ + "media/images/athletes/1985-bc28296b63fca580a350a8b82c732922.png";